module.exports = __webpack_public_path__ + "img/image_case_3.183f2930.png";